import { createSelector } from 'reselect';

import getPickupTimeWithFallback from './getPickupTimeWithFallback';

export interface IPickupSaleBodyContentHttpDto {
  PickupTime: string
}

export default createSelector([getPickupTimeWithFallback], (pickupTime): IPickupSaleBodyContentHttpDto => ({
  PickupTime: pickupTime,
}));
